import { render, staticRenderFns } from "./DashBoardModalComponent.vue?vue&type=template&id=13faafe0&"
import script from "./DashBoardModalComponent.vue?vue&type=script&lang=js&"
export * from "./DashBoardModalComponent.vue?vue&type=script&lang=js&"
import style0 from "./DashBoardModalComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports